import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";

const Payment: React.FC = () => {
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null); // Create a reference for the form
  const userData = useSelector((state: any) => state);
  const {
    prosure: { formDetail, otpVerified, paymentData },
    home: { totalPrice },
  } = userData;
  const currentUrl = window.location.href;
  const isCoversure = currentUrl.includes('https://partner.coversure.in');
  useEffect(() => {
    if (Number(totalPrice) === 0) {
      navigate(ROUTE_PATH.HOME);
    } else if (Object.keys(formDetail)?.length === 0) {
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
    } else if (otpVerified === false) {
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
    } else {
      // Automatically submit the form when the component loads
      if (formRef.current) {
        formRef.current.submit(); // Triggers the form's submit method
      }
    }
  }, []);
  return (
    <>
    <form
      ref={formRef} // Attach the reference to the form element
      action={isCoversure ? 'https://secure.payu.in/_payment' : "https://test.payu.in/_payment"}
      method="post"
    >
      <input type="hidden" name="key" value={paymentData?.key} />
      <input type="hidden" name="txnid" value={paymentData?.transactionId} />
      <input type="hidden" name="productinfo" value="ProSure" />
      <input type="hidden" name="amount" value={totalPrice} />
      <input type="hidden" name="email" value={formDetail?.email} />
      <input type="hidden" name="firstname" value={formDetail?.firstName} />
      <input type="hidden" name="lastname" value={formDetail?.lastName} />
      <input
        type="hidden"
        name="surl"
        value={window.location.origin + ROUTE_PATH.SUCCESS_PAYMENT}
      />
      <input
        type="hidden"
        name="furl"
        value={window.location.origin + ROUTE_PATH.FAILURE_PAYMENT}
      />
      <input type="hidden" name="phone" value={formDetail?.mobileNo} />
      <input
        type="hidden"
        name="hash"
        value={paymentData?.hash}
      />
    </form>
    <div className="w-[100%] h-[100vh] flex items-center justify-center text-[16px] leading-[20px] font-bold">
        Please Wait ...
    </div>
    </>
  );
};

export default Payment;
